export const CustomsClearanceFileTypes = [
    { value: 'INVOICE', label: 'Invoice', icon: 'fa-solid fa-file-invoice' },
    { value: 'PACKING_LIST', label: 'Packing List', icon: 'fa-solid fa-list' },
    { value: 'BL', label: 'BL', icon: 'fa-solid fa-file-lines' },
    { value: 'AWB', label: 'AWB', icon: 'fa-solid fa-file-lines' },
    { value: 'DELIVERY_ORDER', label: 'Delivery Order', icon: 'fa-solid fa-truck-fast' },
    { value: 'CUSTOMS_DECLARATION', label: 'Customs Declaration', icon: 'fa-solid fa-file-shield' },
    { value: 'IMPORT_PERMIT', label: 'Import Permit', icon: 'fa-solid fa-file-import' },
    { value: 'EXPORT_PERMIT', label: 'Export Permit', icon: 'fa-solid fa-file-export' },
    { value: 'CERTIFICATE_OF_ORIGIN', label: 'Certificate of Origin', icon: 'fa-solid fa-certificate' },
    { value: 'OTHER', label: 'Other', icon: 'fa-solid fa-file-circle-plus' },
    { value: 'BAYAN', label: 'Bayan', icon: 'fa-solid fa-file' },
    { value: 'HBL', label: 'HBL', icon: 'fa-solid fa-file-lines' },
    { value: 'MANIFEST', label: 'Manifest', icon: 'fa-solid fa-file-lines' },
    { value: 'CONTAINER_RELEASE', label: 'Container Release', icon: 'fa-solid fa-box-open' },
    { value: 'INSPECTION_REPORT', label: 'Inspection Report', icon: 'fa-solid fa-file-magnifying-glass' },
    { value: 'INSURANCE_CERTIFICATE', label: 'Insurance Certificate', icon: 'fa-solid fa-file-shield' },
    { value: 'TAX_RECEIPT', label: 'Tax Receipt', icon: 'fa-solid fa-receipt' },
    { value: 'PAYMENT_RECEIPT', label: 'Payment Receipt', icon: 'fa-solid fa-receipt' },
    { value: 'QUOTATION', label: 'Quotation', icon: 'fa-solid fa-file-invoice-dollar' },
    { value: 'APPROVAL', label: 'Approval', icon: 'fa-solid fa-thumbs-up' },
    { value: 'AUTHORIZATION', label: 'Authorization', icon: 'fa-solid fa-file-signature' },
    { value: 'COMMERCIAL_INVOICE', label: 'Commercial Invoice', icon: 'fa-solid fa-file-invoice' },
    { value: 'PROFORMA_INVOICE', label: 'Proforma Invoice', icon: 'fa-solid fa-file-invoice' },
    { value: 'CONTRACT', label: 'Contract', icon: 'fa-solid fa-file-signature' },
    { value: 'LICENSE', label: 'License', icon: 'fa-solid fa-id-card' },
    { value: 'PERMIT', label: 'Permit', icon: 'fa-solid fa-id-card' },
    { value: 'APPLICATION', label: 'Application', icon: 'fa-solid fa-file-alt' },
    { value: 'REQUEST', label: 'Request', icon: 'fa-solid fa-file-alt' },
    { value: 'STATEMENT', label: 'Statement', icon: 'fa-solid fa-file-alt' },
    { value: 'REPORT', label: 'Report', icon: 'fa-solid fa-file-alt' },
    { value: 'NOTIFICATION', label: 'Notification', icon: 'fa-solid fa-bell' },
    { value: 'CORRESPONDENCE', label: 'Correspondence', icon: 'fa-solid fa-envelope' },
    { value: 'PHOTO', label: 'Photo', icon: 'fa-solid fa-camera' },
    { value: 'SCAN', label: 'Scan', icon: 'fa-solid fa-scanner' },
    { value: 'DOCUMENT', label: 'Document', icon: 'fa-solid fa-file' },
    { value: 'ATTACHMENT', label: 'Attachment', icon: 'fa-solid fa-paperclip' },
];
